<app-payment-batch-table
  [currentTabname]="tabName"
  [program]="program"></app-payment-batch-table>
